import { useMemo } from "react";

export function useCurrencyFormat(currency: string) {
  return useMemo(() => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch {
      return {
        format(value: number) {
          return `${value} ${currency}`;
        },
      };
    }
  }, [currency]);
}
